import * as React from 'react';
import styled from 'styled-components';

import { Button } from 'components';
import { ButtonProps } from 'components/Button';
import { Color } from '@bb/elements-web';

const AddContactButton: React.FC<ButtonProps> = ({ ...props }) => (
  <StyledButton type="primary" {...props} data-cy="contact-add-button">
    Add Contact
  </StyledButton>
);

const StyledButton = styled(Button)`
  background-color: ${Color.PRIMARY};
  border-color: ${Color.PRIMARY};
`;

export default AddContactButton;
